import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { FlexContainer } from '../../../CSS/index.js';
import ConditionalRender from '../../ConditionalRender/index.js';
import { IconContainer, IconGraphic } from '../../../Icon/index.js';
const SIZE = {
    small: {
        background: 120,
        icon: 80
    },
    medium: {
        background: 150,
        icon: 100
    },
    large: {
        background: 190,
        icon: 120
    }
};
const DashedLine = styled.div(({ size = 'medium' }) => ({
    left: 0,
    height: 65,
    zIndex: -1,
    marginTop: SIZE[size].background / 2 - 33,
    overflow: 'hidden',
    position: 'absolute',
    width: '100%'
}));
export const Illustration = ({ icon, role, size = 'medium', palette = 'light' }) => (_jsxs(FlexContainer, { style: theme => ({
        zIndex: 5,
        margin: '0 auto 30px',
        width: SIZE[size].background,
        height: SIZE[size].background,
        boxShadow: '-45.6859px 51.7088px 54px rgba(64, 110, 142, 0.21), -30.7703px 34.8268px 41.4688px rgba(64, 110, 142, 0.159444), -20.6298px 23.3494px 29.8px rgba(64, 110, 142, 0.127556), -13.9396px 15.7773px 19.4062px rgba(64, 110, 142, 0.105), -9.37505px 10.611px 10.7px rgba(64, 110, 142, 0.0824444), -5.6115px 6.35128px 4.09375px rgba(64, 110, 142, 0.0505556)',
        background: theme.primaryBackgroundColor,
        borderRadius: '100%'
    }), children: [_jsx("figure", { css: css({
                width: SIZE[size].icon,
                height: SIZE[size].icon,
                margin: 'auto',
                position: 'relative'
            }), children: icon }), _jsx(ConditionalRender, { isContentVisible: role !== 'illustration', children: _jsx(DashedLine, { size: size, children: _jsx(IconContainer, { style: theme => ({
                        width: 3000,
                        height: 65,
                        left: -450,
                        color: palette === 'light'
                            ? theme.contourColor
                            : theme.primaryBackgroundColor
                    }), children: _jsx(IconGraphic.SuperDashedLine, {}) }) }) })] }));
//# sourceMappingURL=index.js.map